import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { STRING_UTILS } from "../../../utils/StringUtilities";
import { useLocalStorage } from "@uidotdev/usehooks";
import { RedirectionHelpers, RedirectPayload } from "../../../entities/site/RedirectPayload";

export const AccountNavButton: React.FC = () => {
    const { isAuthenticated, isLoading, logout, loginWithRedirect } = useAuth0();
    const [_, setRedirectTo] = useLocalStorage<RedirectPayload>(RedirectionHelpers.redirectionKey);
    if(isLoading) {
        return null;
    }
    //TODO: Reset state
    const login = () => {
        const cryptoText = STRING_UTILS.generateCryptoString(16);
        let search = "";
        if (window.location.search != null && window.location.search != "") {
            search = `?${window.location.search}`;
        }
        setRedirectTo([cryptoText, `${window.location.pathname}${window.location.hash}${search}`]);
        loginWithRedirect({
            authorizationParams: {
                prompt: "consent",
                redirect_uri: `${window.location.protocol}//${window.location.host}`
            },
            appState: { cryptoText }
        });
    }
    return isAuthenticated
        ? <a onClick={() => logout({ logoutParams: { returnTo: `${window.location.protocol}//${window.location.host}` } })}>Log Out</a>
        : <a onClick={login}>Log In</a>
}